import React, { Component, Fragment } from "react";
import AppContext from "../../../contexts/AppContext";
import BadgeDetailModal from "./BadgeDetailModal";

class BadgesList extends Component {
    state = {      
        item: {},
        apply: false
    };

    toggleApply = () => {
        this.state.apply === true
            ? this.setState({ apply: false })
            : this.setState({ apply: true });
    };

    render() {
        return (
            <Fragment>
                <li className="text-center" onClick={this.toggleApply}>
                    <div className="img-container">
					    <img className={this.props.item.auto === "approved" ? "d-block" : "locked d-block"} src={this.props.item.image} alt={this.props.item.name} title={this.props.item.name}/>
					</div>
					<p className="mt-4 text-center">{this.props.item.name}</p>
                </li>

                {this.state.apply === true ? (
                    <BadgeDetailModal
                        item={this.props.item}
                        apply={this.props.apply}
                        toggleApply={this.toggleApply}
                    ></BadgeDetailModal>
                ) : null}
            </Fragment>
        );
    }
}
BadgesList.contextType = AppContext;
export default BadgesList;



// WEBPACK FOOTER //
// ./src/components/writer/writerBadges/BadgeList.js